import React from "react";
import {
  Badge,
  Card,
  CardBody,
  CardHeader,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { CARD_HELP_TEXT, CardHeadingWithHelp } from "../shared/help";

const PayslipsSection = ({ payslips, user, meta, formatPayrollCurrency }) => (
  <Card>
    <CardHeader>
      <CardHeadingWithHelp
        title="Payslip Records"
        helpText={CARD_HELP_TEXT.payslipRecords}
      />
    </CardHeader>
    <CardBody>
      <TableContainer>
        <Table size="sm">
          <Thead>
            <Tr>
              <Th>Employee</Th>
              <Th>Run</Th>
              <Th>Gross</Th>
              <Th>Deductions</Th>
              <Th>Net Pay</Th>
              <Th>Locked</Th>
            </Tr>
          </Thead>
          <Tbody>
            {payslips.map((payslip) => (
              <Tr key={payslip._id}>
                <Td>{payslip.userId?.name || user?.name || "Self"}</Td>
                <Td>{`${payslip.payrollRunId?.month || "-"}/${payslip.payrollRunId?.year || "-"}`}</Td>
                <Td>{formatPayrollCurrency(payslip.gross, meta)}</Td>
                <Td>{formatPayrollCurrency(payslip.totalDeductions, meta)}</Td>
                <Td>{formatPayrollCurrency(payslip.netPay, meta)}</Td>
                <Td>
                  <Badge colorScheme={payslip.isLocked ? "green" : "orange"}>
                    {payslip.isLocked ? "Locked" : "Draft"}
                  </Badge>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </CardBody>
  </Card>
);

export default PayslipsSection;
